<template>
  <div class="shift-navigation" :data-testid="testId">
    <a-button
      type="primary"
      size="small"
      class="flex align-items-center"
      :disabled="!hasPrevious || disabled"
      :data-testid="previousButtonTestId"
      @click="navigateToPrevious"
    >
      <a-icon width="20" height="20" icon="mdi:arrow-left" />
    </a-button>

    <a-button
      type="primary"
      class="flex align-items-center"
      size="small"
      :disabled="!hasNext || disabled"
      :data-testid="nextButtonTestId"
      @click="navigateToNext"
    >
      <a-icon width="20" height="20" icon="mdi:arrow-right" />
    </a-button>
  </div>
</template>

<script>
export default {
  name: 'ShiftNavigation',
  props: {
    current: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    testId: {
      type: String,
      default: undefined
    },
    previousButtonTestId: {
      type: String,
      default: undefined
    },
    nextButtonTestId: {
      type: String,
      default: undefined
    }
  },
  computed: {
    hasPrevious() {
      return this.current > 0
    },
    hasNext() {
      return this.current < this.total - 1
    }
  },
  methods: {
    navigateToPrevious() {
      if (this.hasPrevious) {
        this.$emit('navigate', this.current - 1)
      }
    },
    navigateToNext() {
      if (this.hasNext) {
        this.$emit('navigate', this.current + 1)
      }
    }
  }
}
</script>

<style scoped>
.shift-navigation {
  display: flex;
  align-items: center;
  gap: 12px;
  position: absolute;
  top: -40px;
  left: 0;
}
</style>
